import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Prices from '@/app/Pricing/Prices';
import Flex from '@/components/common/Flex';
import type { UpgradeProps, UpgradeSelectedTariff } from '../types/purchaseTypes';

function Upgrade({ isMemberStep = false, hideFooter = false }: UpgradeProps) {
  const [selectedTariff, setSelectedTariff] = useState<UpgradeSelectedTariff>(null);
  const shouldHideFooter = hideFooter || isMemberStep;

  return (
    <>
      <div className={isMemberStep ? '' : 'py-4'}>
        <Prices
          selectedTariff={selectedTariff}
          setSelectedTariff={setSelectedTariff}
          isMemberStep={isMemberStep}
        />
      </div>
      {!shouldHideFooter && (
        <Flex
          className="mt-3 px-md-6 bg-body-tertiary d-flex card-footer"
          justifyContent="end"
        >
          <div id="FeatureSubmit" className="d-flex gap-3">
            <Link to={`/prorogate-or-upgrade`}>
              <Button variant="secondary">قبلی</Button>
            </Link>
            <Link
              className={
                selectedTariff?.price_slug === 'special' ? 'disabled-link' : ''
              }
              to={`/prorogate-or-upgrade/order?t=${selectedTariff?.price_slug}&wu=${selectedTariff?.weekly_updates}`}
            >
              <Button variant="falcon-primary">بعدی</Button>
            </Link>
          </div>
        </Flex>
      )}
    </>
  );
};

export default Upgrade;
